import { CalcRequestItem } from "./calc-request";
import { PaymentConst } from "@graffer-inc/cloud-gov-core";

export class CalcRequestItemValidator {
  constructor(readonly item: CalcRequestItem) {}

  validate(): {
    amount?: string;
    description?: string;
  } {
    const error: {
      amount?: string;
      description?: string;
    } = {};
    if (this.item.amount <= 0) {
      error["amount"] = "1以上の整数を入力してください";
    }
    if (
      !this.item.description ||
      this.item.description.length > PaymentConst.MAX_DESCRIPTION_LENGTH
    ) {
      error["description"] = "費目は20文字までの入力できます";
    }
    return error;
  }
}
